// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-2XkNh";
var _3 = "airline-mMNeY";
var _4 = "airline__number-1qyjQ";
var _5 = "airline__name-3qSAw";
var _6 = "flight-3tagq";
var _7 = "aircraft__nameTitle-2xqSo";
var _8 = "amenities__item-3oLph";
export { _1 as "__esModule", _2 as "wrapper", _3 as "airline", _4 as "airline__number", _5 as "airline__name", _6 as "flight", _7 as "aircraft__nameTitle", _8 as "amenities__item" }
export default { "__esModule": _1, "wrapper": _2, "airline": _3, "airline__number": _4, "airline__name": _5, "flight": _6, "aircraft__nameTitle": _7, "amenities__item": _8 }
